<template>

	<template v-if="userHaveAccessToCompany">
		<template v-if="companyIsLoaded && !isLoadingAllDataOfCompany">

			<template v-if="companyActiveLicense">
				<div class="app-main-company-header">
					<AppHeader
						v-bind="appHeaderProps"
					/>
				</div>
				<v-main
					class="app-main-company-screen"
				>
					<router-view/>
				</v-main>
			</template>

			<template v-else>
				<div class="d-flex flex-column justify-center align-center h-100 text-center text-h4">
					<CompanyNoLicense/>
				</div>
			</template>

		</template>
		<template v-else>
			<div class="d-flex flex-column justify-center align-center h-100 text-center text-h4">
				<ao-preloader/>
			</div>
		</template>
	</template>

	<template v-else>
		<div class="d-flex flex-column justify-center align-center h-100 text-center text-h4">
			{{ $t('No access to this company') }}
		</div>
	</template>

	<SearchDialog
		:is-search="false"
		@close="() => {}"
	/>

</template>

<script setup>
import { computed, watch, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

/** Components */
import AppHeader from '@/components/base/AppHeader.vue'
import SearchDialog from "@/components/company/SearchDialog.vue";
import CompanyNoLicense from '@/components/company/CompanyNoLicense.vue'

/* Stores */
import { useUserStore } from '@/stores/userStore'
import { useCompanyStore } from '@/stores/companyStore'
import { useCompanyNotificationStore } from '@/stores/companyNotificationStore'
import { useCompanyFavoriteLinksStore } from '@/stores/companyFavoriteLinksStore'

/* BL */
import useCurrentCompany from '@/composables/data/useCurrentCompany'

/* Configs */
import { NAVIGATION_LAYERS } from '@/config/router/routerMapConfig'

const { t: $t } = useI18n()

const route = useRoute()
const router = useRouter()

const userStore = useUserStore()
const {
	selectedCompanyId,
	availableCompanies,
	userHaveAccessToCompany,
} = storeToRefs(userStore)
const {
	setUserHaveAccessToCompanyStatus,
} = userStore

const companyStore = useCompanyStore()
const {
	companyIsLoaded,
	companyActiveLicense,
} = storeToRefs(companyStore)

const {
	isLoadingAllDataOfCompany,
	getAllDataOfCompany,
} = useCurrentCompany()

const companyNotificationStore = useCompanyNotificationStore()

const companyFavoriteLinksStore = useCompanyFavoriteLinksStore()
const {
	getFirstOrCreateFavoritesPreset,
} = companyFavoriteLinksStore


const appHeaderProps = computed(() => {
	let isShowActions = false
	const GROUP_ROUTE = route.matched.find((item) => {
		return NAVIGATION_LAYERS.group.includes(item.meta.navigationRouteType)
	})
	const MODULE_ROUTE = route.matched.find((item) => {
		return NAVIGATION_LAYERS.module.includes(item.meta.navigationRouteType)
	})
	const VIEW_ROUTE = route.matched.find((item) => {
		return NAVIGATION_LAYERS.page.includes(item.meta.navigationRouteType)
	})

	let title = ''
	let moduleLinks = []

	if (GROUP_ROUTE) {
		if (GROUP_ROUTE.meta.navigationRouteType === 'group')
			isShowActions = true

		title = GROUP_ROUTE.meta.titleTranslationKey ? $t(GROUP_ROUTE.meta.titleTranslationKey) : GROUP_ROUTE.meta.title

		moduleLinks = GROUP_ROUTE.children
	}

	let currentModuleRouteName = ''
	let viewTabs = []

	if (MODULE_ROUTE) {
		viewTabs = MODULE_ROUTE.children
		currentModuleRouteName = MODULE_ROUTE.name
	}

	let currentViewRouteName = ''

	if (VIEW_ROUTE) {
		currentViewRouteName = VIEW_ROUTE.name
	}

	return {
		isShowActions,
		title,
		modules: moduleLinks,
		currentModuleRouteName,
		tabRoutes: viewTabs,
		currentViewRouteName,
	}
})

watch(selectedCompanyId, async (newVal) => {
	if (newVal) {
		const isAvailableCompany = availableCompanies.value.findIndex((el) => (el.id === newVal)) >= 0
		if (isAvailableCompany) {
			router.push({
				params: {
					...route.params,
					companyId: newVal,
				},
				query: {
					...route.query,
				},
			})
			await setUserHaveAccessToCompanyStatus(true)
			await getAllDataOfCompany()
			companyNotificationStore.subscribeToNotifications()
			getFirstOrCreateFavoritesPreset()
		} else {
			setUserHaveAccessToCompanyStatus(false)
			// console.log('what????')
		}
	}
}, {
	immediate: true,
})

onUnmounted(() => {
	companyNotificationStore.unsubscribeToNotifications()
})

</script>

<style lang="scss">
.app-main-company-screen {
	height: 100vh;
	height: 100dvh;
	overflow-y: auto;
}
</style>
